import { Day } from "@prisma/client";
import { addDays, isAfter } from "date-fns";

export const days: Day[] = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

export const displayedDays: Day[] = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export const getDayDisplayOrderIndex = (day: Day) => displayedDays.indexOf(day);

export const getDayLabel = (day: Day) => {
  switch (day) {
    case "monday":
      return "Lundi";
    case "tuesday":
      return "Mardi";
    case "wednesday":
      return "Mercredi";
    case "thursday":
      return "Jeudi";
    case "friday":
      return "Vendredi";
    case "saturday":
      return "Samedi";
    case "sunday":
      return "Dimanche";
  }
};

export function getDaysInRange(startDate: Date, endDate: Date) {
  const currentDays: string[] = [];
  let currentDate = new Date(startDate);
  while (!isAfter(currentDate, endDate) && currentDays.length < 7) {
    currentDays.push(days[currentDate.getDay()]);
    currentDate = addDays(currentDate, 1);
  }
  return currentDays;
}
